import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
//import { getDocumentsLocation } from "../services/soar";

function DocumentsIcon({
  id,
  clientDocInfo,
  fosterHomeDocInfo,
  hideIfNone,
  path,
}) {
  // const [location, setLocation] = useState({});
  // const [url, setUrl] = useState();
  // const isMountedRef = useRef(true);
  const navigate = useNavigate();

  // useEffect(() => {
  //   return () => (isMountedRef.current = false);
  // }, []);

  // useEffect(() => {
  //   if (clientId && process.env.REACT_APP_ENVIRONMENT === "Production") {
  //     setUrl("https://soardocs.safy.org/contact/");
  //     console.log("Getting Document Location for ", clientId);
  //     getDocumentsLocation(clientId).then((response) => {
  //       console.log("Location: ", JSON.stringify(response));
  //       if (response && response.length > 0 && isMountedRef.current) {
  //         setLocation(response[0]);
  //       }
  //     });
  //   }
  // }, [clientId]);

  // useEffect(() => {
  //   if (clientDocInfo && process.env.REACT_APP_ENVIRONMENT === "Production") {
  //     setUrl("https://soardocs.safy.org/contact/");
  //     setLocation(clientDocInfo);
  //   }
  // }, [clientDocInfo]);

  // useEffect(() => {
  //   if (
  //     fosterHomeDocInfo &&
  //     process.env.REACT_APP_ENVIRONMENT === "Production"
  //   ) {
  //     setUrl("https://soardocs.safy.org/ccx_fostercarehome/");
  //     setLocation(fosterHomeDocInfo);
  //   }
  // }, [fosterHomeDocInfo]);

  // const openDocumentLocation = () => {
  //   console.log("LocButton", location);
  //   if (
  //     Object.keys(location).length > 0 &&
  //     location[`${clientId === undefined ? "doc." : ""}relativeurl`]
  //   ) {
  //     window.open(
  //       `${url}${
  //         location[`${clientId === undefined ? "doc." : ""}relativeurl`]
  //       }`,
  //       "documents"
  //     );
  //   } else if (
  //     Object.keys(location).length > 0 &&
  //     location[`${clientId === undefined ? "doc." : ""}absoluteurl`]
  //   ) {
  //     window.open(
  //       `${location[`${clientId === undefined ? "doc." : ""}absoluteurl`]}`,
  //       "documents"
  //     );
  //   } else {
  //     if (clientId) alert("There are no documents set up for this client");
  //     else if (clientDocInfo)
  //       alert("There are no documents set up for this client");
  //     else if (fosterHomeDocInfo)
  //       alert("There are no documents set up for this foster home");
  //   }
  // };

  return process.env.REACT_APP_ENVIRONMENT === "Production" ? (
    <i
      className="fas fa-folder fa-2x me-2"
      title="Documents"
      style={{ color: "#F0AD4E" }}
      onClick={() =>
        navigate(`/${path}/${id}`, {
          state: { tab: "documents" },
        })
      }
    ></i>
  ) : null;
}

export default DocumentsIcon;
